'use client';

import {
    Input,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@repo/shadcn';
import { useEffect, useRef } from 'react';

interface DiscountValueProps {
    discount: {
        value: number;
        type: string;
    };
    handleDiscountChange: (field: 'value' | 'type', value: any) => void;
    // onKeyDown: (event: React.KeyboardEvent) => void;
}

export function Discount({
    handleDiscountChange,
    discount,
}: DiscountValueProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, []);

    return (
        <div className=" flex w-full rounded-md border-[1px] bg-white">
            <Input
                ref={inputRef}
                className="max-w-[50px] border-none p-0 text-center text-[22px] font-semibold text-primary focus:border-none focus-visible:ring-0 focus-visible:ring-offset-0"
                onChange={(e) => handleDiscountChange('value', e.target.value)}
                value={discount?.value ?? 0}
                name="value"
                onFocus={(e) => e.target.select()}
            />
            <Select
                value={discount?.type ?? 'fixed'}
                onValueChange={(value) => handleDiscountChange('type', value)}
                name="type"
                defaultValue="fixed"
            >
                <SelectTrigger className="w-[60px] border-none bg-slate-200 text-[18px] font-semibold text-primary focus:border-none focus:ring-0 focus:ring-offset-0">
                    <SelectValue placeholder="Type" />
                </SelectTrigger>
                <SelectContent className="!w-[60px] font-semibold">
                    <SelectItem value="fixed" className="px-4">
                        ৳
                    </SelectItem>
                    <SelectItem value="percentage" className="px-4">
                        %
                    </SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
}
